import { GET, POST } from "../utils/crud"

const states = async () => {
  const response = await GET("states")
  if (response.error) return { error: response.error }
  return response.data
}
const services = async () => {
  const response = await GET("parameters/services")
  if (response.error) return { error: response.error }
  return response.data
}

const pqrType = async () => {
  const response = await GET("parameters/ticket_types")
  if (response.error) return { error: response.error }
  return response.data
}

const whoResides = async () => {
  const response = await GET("parameters/settler_types")
  if (response.error) return { error: response.error }
  return response.data
}

const headquarter = async () => {
  const response = await GET("parameters/headquarters")
  if (response.error) return { error: response.error }
  return response.data
}

const gender = async () => {
  const response = await GET("parameters/gender")
  if (response.error) return { error: response.error }
  return response.data
}

const documentType = async () => {
  const response = await GET("parameters/document_type")
  if (response.error) return { error: response.error }
  return response.data
}

const eps = async () => {
  const response = await GET("parameters/eps")
  if (response.error) return { error: response.error }
  return response.data
}

const counties = async (id) => {
  const response = await GET(`states/${id}/counties`)
  if (response.error) return { error: response.error }
  return response.data
}

const user = async (document_type, document_num) => {
  const response = await GET(
    `users?document_type=${document_type}&document_number=${document_num}`
  )
  if (response.error) return { error: response.error }
  return response.data
}

const sendPqr = async (body) => {
  const res = await POST("save-pqrsf", body)
  return res
}

const getTickets = async (id) => {
  const response = await GET(`tickets/${id}`)
  return response
}

export default {
  states,
  services,
  pqrType,
  whoResides,
  headquarter,
  gender,
  documentType,
  eps,
  counties,
  user,
  sendPqr,
  getTickets,
}
